import { Fragment } from 'react';
import { createPortal } from 'react-dom';
import { Icon } from 'semantic-ui-react';
import collect from 'collect.js';

import './SlideoutPanel.scss';

const SlideoutPanel = ({
  open,
  onClose,
  title,
  actions,
  className = '',
  wide = false,
  children,
}) => {
  return createPortal(
    <Fragment>
      {open && <div className="slideout-panel-backdrop" onClick={onClose} />}
      <div
        className={collect([
          'slideout-panel',
          className,
          wide
            ? ` slideout-panel--${typeof wide === 'string' ? wide : 'wide'}`
            : null,
          open ? 'open' : null,
        ])
          .filter()
          .join(' ')}
      >
        <div className="slideout-panel-body">
          <div className="slideout-panel-header">
            <span>{title}</span>
            <Icon name="close" link onClick={onClose} />
          </div>
          {actions && <div className="slideout-panel-actions">{actions}</div>}
          <div className="slideout-panel-content">{children}</div>
        </div>
      </div>
    </Fragment>,
    document.body
  );
};

export { SlideoutPanel };
